import { cache } from 'react';
import client from '@/clients/customer/api-client';
import Qs from 'qs';
import { withCacheTTL } from '../common/with-cache-ttl';

export const search = (filter: any | null = null, headers = {}) => {
  return client.get('/restaurants', {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
    headers,
  });
};

export const shopsInCityService = (
  slug: string,
  filter: any | null = null,
  headers = {}
) => {
  return client.get(`/cities/${slug}/restaurants`, {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
    headers,
  });
};

// Wrap the fetching function with caching and a TTL of 1 minute
export const cachedSearch = withCacheTTL(search, '/restaurants');

export const restaurantDetailsService = cache((slug: string, headers: any) => {
  return client.get(`/restaurants/${slug}`, {
    headers,
  });
});

export const getCoupon = (slug: string | number, code: string, data: any) => {
  return client.post(`/restaurants/${slug}/${code}/coupon`, data);
};

export const restaurantReviewesService = (slug: string, headers: any) => {
  return client.get(`/restaurants/${slug}/reviews`, {
    headers,
  });
};

export const getRestaurantsByCityID = (
  id: number,
  filter: any | null = null,
  headers = {}
) =>
  client.get(`/cities/${id}/restaurants`, {
    params: filter,
    paramsSerializer(params) {
      return Qs.stringify(params, { arrayFormat: 'brackets' });
    },
    headers,
  });
